export default __webpack_public_path__ + "static/media/abaf_sessao_01.c0ee227b.png";